import axios from "axios";
import { store } from "../store";
import {
  CREATE_CREATOR_SESSION,
  GET_ALL_CREATOR_SESSIONS,
  GET_CREATOR_SESSION_BY_ID,
  UPDATE_CREATOR_SESSION,
  DELETE_CREATOR_SESSION,
  CREATE_CREATOR_AVAILABILITY,
  GET_CREATOR_AVAILABILITY,
  UPDATE_CREATOR_AVAILABILITY,
  DELETE_CREATOR_AVAILABILITY,
  CREATE_BOOKING,
  GET_CREATOR_BOOKINGS,
  GET_BOOKING_BY_ID,
  UPDATE_BOOKING,
  DELETE_BOOKING,
  GET_AVAILABLE_TIME_SLOTS,
  CREATE_SESSION_RATING,
  GET_SESSION_RATINGS,
  UPDATE_SESSION_RATING,
  GET_CREATOR_DASHBOARD,
  MINDFULNESS_LOADING,
  MINDFULNESS_ERROR,
  GET_ALL_CREATORS,
  SEARCH_SESSION_WITH_FILTERS,
  GET_USER_DASHBOARD,
  GET_CREATOR_BOOKING,
  GET_USER_BOOKINGS,
  CREATE_SESSION_PAYMENT,
  SESSION_PAYMENT_SUCCESS,
  SESSION_PAYMENT_FAILURE,
  USER_PAYMENT_HISTORY,
  CREATOR_PAYMENT_HISTORY,
} from "../constants/actionTypes";
import {
  CREATOR_SESSION_API,
  CREATOR_AVAILABILITY_API,
  BOOKINGS_API,
  CREATOR_BOOKINGS_API,
  SESSION_RATING_API,
  CREATOR_DASHBOARD_API,
  CREATOR_SEARCH_API,
  GET_AVAILABLE_TIME_SLOTS_API,
  SEARCH_SESSION_API,
  USER_DASHBOARD_API,
  GET_USER_BOOKINGS_API,
  CREATE_SESSION_PAYMENT_API,
  SESSION_PAYMENT_SUCCESS_API,
  SESSION_PAYMENT_FAILURE_API,
  GET_USER_PAYMENT_HISTORY_API,
  GET_CREATOR_PAYMENT_HISTORY_API,
  GET_BOOKING_INVOICE,
} from "../constants/apis";
import { errorMessageFromResponse } from "../constants/commonFunctions";
import { handleErrorMessage } from "./classes";
import { handleSuccessMessage } from "./success";

// Helper function to set loading state
const setLoading = (isLoading) => ({
  type: MINDFULNESS_LOADING,
  payload: isLoading,
});

// Helper function to set error state
const setError = (error) => ({
  type: MINDFULNESS_ERROR,
  payload: error,
});

// ============= CREATOR SESSION ACTIONS =============

export function createCreatorSession(sessionData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.post(CREATOR_SESSION_API, sessionData, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: CREATE_CREATOR_SESSION,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getAllCreators() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(CREATOR_SEARCH_API, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_ALL_CREATORS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function searchSessionWithFilters(options) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

  const params = {
    ...(options.limit && { limit: options.limit }),
    ...(options.gender && { gender: options.gender }),
    ...(options.language && { language: options.language }),
    ...(options.sessionName && { session_name: options.sessionName }),
    ...(options.creatorName && { creator_name: options.creatorName }),
    ...(options.sessionType && { session_type: options.sessionType }),
    ...(options.ratings && { ratings: options.ratings }),
    ...(options.category && { category: options.category })
  };

    try {
      const response = await axios.get(SEARCH_SESSION_API, {
        headers,
        params,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: SEARCH_SESSION_WITH_FILTERS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}


export function getAllCreatorSessions() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(CREATOR_SESSION_API, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_ALL_CREATOR_SESSIONS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getCreatorSessionById(sessionId) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(`${CREATOR_SESSION_API}${sessionId}/`, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_CREATOR_SESSION_BY_ID,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function updateCreatorSession(sessionId, sessionData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.patch(
        `${CREATOR_SESSION_API}${sessionId}/`,
        sessionData,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: UPDATE_CREATOR_SESSION,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function deleteCreatorSession(sessionId) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.delete(
        `${CREATOR_SESSION_API}${sessionId}/`,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: DELETE_CREATOR_SESSION,
          payload: sessionId,
        });
        dispatch(setLoading(false));
        return { success: true };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

// ============= CREATOR AVAILABILITY ACTIONS =============

export function createCreatorAvailability(availabilityData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.post(
        CREATOR_AVAILABILITY_API,
        availabilityData,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: CREATE_CREATOR_AVAILABILITY,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getCreatorAvailability() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(CREATOR_AVAILABILITY_API, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_CREATOR_AVAILABILITY,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function updateCreatorAvailability(availabilityId, availabilityData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.patch(
        `${CREATOR_AVAILABILITY_API}${availabilityId}/`,
        availabilityData,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: UPDATE_CREATOR_AVAILABILITY,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function deleteCreatorAvailability(availabilityId) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.delete(
        `${CREATOR_AVAILABILITY_API}${availabilityId}/`,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: DELETE_CREATOR_AVAILABILITY,
          payload: availabilityId,
        });
        dispatch(setLoading(false));
        return { success: true };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

// ============= BOOKING ACTIONS =============

export function createBooking(bookingData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.post(BOOKINGS_API, bookingData, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch(
          handleSuccessMessage("Payment Successful and session booked!"),
        );
        dispatch({
          type: CREATE_BOOKING,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getCreatorBookings(bookingId = null) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    const url = bookingId
      ? `${CREATOR_BOOKINGS_API}?booking_id=${bookingId}`
      : CREATOR_BOOKINGS_API;

    try {
      const response = await axios.get(url, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: bookingId ? GET_CREATOR_BOOKING : GET_CREATOR_BOOKINGS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getBookingById(bookingId) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(`${BOOKINGS_API}${bookingId}/`, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_BOOKING_BY_ID,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getAllUserBookings() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(`${GET_USER_BOOKINGS_API}`, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_USER_BOOKINGS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function updateBooking(bookingId, bookingData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.patch(
        `${BOOKINGS_API}${bookingId}/`,
        bookingData,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: UPDATE_BOOKING,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function deleteBooking(bookingId) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.delete(
        `${CREATOR_BOOKINGS_API}${bookingId}/`,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: DELETE_BOOKING,
          payload: bookingId,
        });
        dispatch(setLoading(false));
        return { success: true };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getBookingInvoice(bookingId) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(
        `${GET_BOOKING_INVOICE}${bookingId}/bookingInvoice/`,
        { headers, responseType: "blob" },
      );

      if (response.status >= 200 && response.status < 300) {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" }),
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `invoice_booking_${bookingId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { success: true };
      }
    } catch (error) {
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      return { success: false, error };
    }
  };
}

export function getAvailableTimeSlots(sessionData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.post(
        GET_AVAILABLE_TIME_SLOTS_API,
        sessionData,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_AVAILABLE_TIME_SLOTS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

// ============= SESSION RATING ACTIONS =============

export function rateAndReviewSession({ creatorSessionId, rating, review }) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    };

    try {
      const formData = new FormData();
      formData.append("creator_session", creatorSessionId);
      formData.append("rating", rating);
      if (review) formData.append("review", review);

      const response = await axios.post(SESSION_RATING_API, formData, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: CREATE_SESSION_RATING,
          payload: response?.data?.data,
        });
        dispatch(handleSuccessMessage("Review submitted successfully!"));
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function createSessionRating(ratingData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.post(SESSION_RATING_API, ratingData, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: CREATE_SESSION_RATING,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getSessionRatings(sessionId = null) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    const url = sessionId
      ? `${SESSION_RATING_API}?session_id=${sessionId}`
      : SESSION_RATING_API;

    try {
      const response = await axios.get(url, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_SESSION_RATINGS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function updateSessionRating(ratingId, ratingData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.patch(
        `${SESSION_RATING_API}${ratingId}/`,
        ratingData,
        { headers },
      );

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: UPDATE_SESSION_RATING,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

// ============= CREATOR DASHBOARD ACTIONS =============

export function getCreatorDashboard() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(CREATOR_DASHBOARD_API, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_CREATOR_DASHBOARD,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getUserDashboard() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    try {
      const response = await axios.get(USER_DASHBOARD_API, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: GET_USER_DASHBOARD,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

// ============= PAYMENT ACTIONS =============

export function createSessionPayment(paymentData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    };

    try {
      const formData = new FormData();
      formData.append("currency", paymentData.currency);
      formData.append("service", paymentData.service);
      formData.append("product_id", paymentData.product_id);
      formData.append("creator_session_type", paymentData.creator_session_type);

      const response = await axios.post(CREATE_SESSION_PAYMENT_API, formData, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: CREATE_SESSION_PAYMENT,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function sessionPaymentSuccess(paymentData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    };

    try {
      const formData = new FormData();
      formData.append("razorpay_payment_id", paymentData.razorpay_payment_id);
      formData.append("razorpay_order_id", paymentData.razorpay_order_id);
      formData.append("razorpay_signature", paymentData.razorpay_signature);

      const response = await axios.put(SESSION_PAYMENT_SUCCESS_API, formData, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: SESSION_PAYMENT_SUCCESS,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function sessionPaymentFailure(paymentData) {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    };

    try {
      const formData = new FormData();
      formData.append("order_id", paymentData.order_id);
      formData.append("payment_id", paymentData.payment_id);
      formData.append("code", paymentData.code);
      formData.append("description", paymentData.description);
      formData.append("reason", paymentData.reason);
      formData.append("step", paymentData.step);
      formData.append("source", paymentData.source);

      const response = await axios.put(SESSION_PAYMENT_FAILURE_API, formData, {
        headers,
      });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: SESSION_PAYMENT_FAILURE,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}


// Payment History


export function getUserPaymentHistory() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    const url = GET_USER_PAYMENT_HISTORY_API;

    try {
      const response = await axios.get(url, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: USER_PAYMENT_HISTORY,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}

export function getCreatorPaymentHistory() {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    dispatch(setLoading(true));
    const headers = {
      Authorization: `Token ${token}`,
    };

    const url = GET_CREATOR_PAYMENT_HISTORY_API;

    try {
      const response = await axios.get(url, { headers });

      if (response.status >= 200 && response.status < 300) {
        dispatch({
          type: CREATOR_PAYMENT_HISTORY,
          payload: response?.data?.data,
        });
        dispatch(setLoading(false));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(setError(errorMessageFromResponse(error)));
      dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      dispatch(setLoading(false));
      return { success: false, error };
    }
  };
}
